import { notEmpty } from '../../utils/validator'
export default {
  className: '_User',
  tableSize: 'small',
  render (record) {
    return record.username || '-'
  },
  mixin: {
    search: [
      'nickName',
      'phone',
      'username'
    ],
    fields: [
      {
        name: 'hierarchy',
        validators: [
          notEmpty()
        ]
      },
      {
        name: 'nickName',
        validators: [
          notEmpty()
        ]
      },
      {
        name: 'phone',
        validators: [
          notEmpty()
        ]
      },
      {
        name: 'username',
        validators: [
          notEmpty()
        ]
      },
      {
        name: 'status',
        validators: [
          notEmpty()
        ]
      }
    ]
  }
}
